<template>
  <div class="d-flex flex-column justify-start" style="min-width:95vw; max-width:95vw">
    <div class="d-flex flex-row w-50 pa-10">
      <v-text-field
          v-model="eVoucherNumberSearch"
          label="EVoucher Number"
          required
          density="compact"
          variant="outlined"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>          
        <v-btn class="ml-2" @click="evoucherSearch" icon="mdi-magnify" variant="text" />
    </div>        

    <div v-show="!hasEVoucher">
      {{ noEVoucher }}
    </div>

    <v-container v-show="hasEVoucher">
      <v-row no-gutters>

        <div class="evoucherList">
          <v-data-table
            :items-per-page="5" 
            :items-per-page-options="[5, 10, -1]"
            :headers="headers"
            :items="evouchers" item-key="id"
            density="compact"
            class="border-md elevation-15"
            style="width: 400px;"
            role="table"
            aria-label="eVoucher management data">

              <template v-slot:item.load="{ item }">
                <v-btn v-show="item.eVoucherNumber === eVoucherNumberSearch" density="compact" @click="loadEVoucher(item.eVoucherNumber)" size="small" icon="mdi-magnify" color="success" aria-label="Load selected eVoucher" /> 
                <v-btn v-show="item.eVoucherNumber !== eVoucherNumberSearch" density="compact" @click="loadEVoucher(item.eVoucherNumber)" size="small" icon="mdi-magnify" aria-label="Load this eVoucher" /> 
              </template>              
          </v-data-table>
        </div>

        <v-col>
          <v-sheet class="px-2 mx-2 mb-2">
            <span class="title">EVoucher Number</span> <br/>
            <span class="sub-title">{{evoucher.eVoucherNumber}}</span> <br/> <br/>

            <span class="title">Quarter</span> <br/>
            <span class="sub-title">{{evoucher.quarter}}</span> <br/> <br/>

            <span class="title">Expiry Date</span> <br/>
            <span class="sub-title">{{$filters.toNiceDate(evoucher.eVoucherExpiryDate)}}</span> <br/> <br/>
            
            <span class="title">EVoucher Amount</span> <br/>
            <span class="sub-title">USD {{$filters.toGenericCurrency(evoucher.usdAmount)}}</span> <br/> <br/>

            <span class="title">Partner</span> <br/>
            <span class="sub-title">{{evoucher.partnerAffinityId}}</span> <br/>
            <span class="sub-title">{{evoucher.partnerName}}</span> <br/>
            <span class="sub-title">{{evoucher.partnerCountry}}</span> <br/> 

          </v-sheet>
        </v-col>
        
        <v-col>
          <v-sheet class="px-2 mx-2 mb-2">
            <span class="title">Status</span> <br/>
            <span class="sub-title">
              {{evoucher.eVoucherStatus}} <span v-if="evoucher.reissuedEVoucherNumber != ''">
                (Re-issued as {{ evoucher.reissuedEVoucherNumber }} <v-btn density="compact" @click="loadReissuedEVoucher" size="small" icon="mdi-magnify" /> )
              </span>
            </span> <br/> <br/>

            <span class="title">Payment Reference</span> <br/>
            <span class="sub-title">{{evoucher.paymentReference}}</span> <br/> <br/>

            <span v-if="evoucher.eVoucherStatusLink === 12" class="title">Date Cancelled<br/></span> 
            <span v-if="evoucher.eVoucherStatusLink === 12" class="sub-title">{{$filters.toNiceDate(evoucher.eVoucherCancelledDate)}}<br/><br/></span>
            <span v-if="evoucher.eVoucherStatusLink === 13" class="title">Date Redeemed<br/></span> 
            <span v-if="evoucher.eVoucherStatusLink === 13" class="sub-title">{{$filters.toNiceDate(evoucher.eVoucherRedeemedDate)}}<br/><br/></span>
            <span v-if="evoucher.eVoucherStatusLink === 14" class="title">Date Utilized<br/></span> 
            <span v-if="evoucher.eVoucherStatusLink === 14" class="sub-title">{{$filters.toNiceDate(evoucher.eVoucherUtilizedDate)}}<br/><br/></span>
 
            <span class="title">EVoucher Local Amount</span> <br/>
            <span class="sub-title">{{evoucher.localCurrency}} {{$filters.toGenericCurrency(evoucher.localAmount)}}</span> <br/> <br/>

            <span class="title">Distributor</span> <br/>
            <span class="sub-title">{{evoucher.distributorAffinityId}}</span> <br/>
            <span class="sub-title">{{evoucher.distributorName}}</span> <br/>
            <span class="sub-title">{{evoucher.distributorCountry}}</span> <br/>
          </v-sheet>
        </v-col>

        <v-responsive width="100%"></v-responsive>
             
        <v-col cols="3"> 
          <br/><br/>           
          <div class="d-flex flex-row">
            <v-sheet class="px-2 mx-2 mb-2">
              <v-btn class="ml-2" @click="viewGuide" prepend-icon="mdi-help-circle">
                View Guide
              </v-btn>              
            </v-sheet>
            <v-sheet v-if="canResendEmail" class="px-2 mx-2 mb-2">
              <v-btn class="ml-2" @click="showSendEmailDialog = true" prepend-icon="mdi-email-sync-outline">
              Re-send Email
              </v-btn>
            </v-sheet>
            <v-sheet v-if="canEntendExpiryDate" class="px-2 mx-2 mb-2">
              <v-btn class="ml-2" @click="showExtendExpiryDateDialog = true" prepend-icon="mdi-sort-calendar-descending">
              Extend Expiry Date
              </v-btn>
            </v-sheet>
            <v-sheet v-if="canReissueEVoucher" class="px-2 mx-2 mb-2">
              <v-btn class="ml-2" @click="showReissueDialog = true" prepend-icon="mdi-book-sync-outline">
              Re-issue EVoucher
              </v-btn>
            </v-sheet>          
            <v-sheet v-if="canCancelEVoucher" class="px-2 mx-2 mb-2">
              <v-btn class="ml-2" @click="showCancelEVoucherDialog = true" prepend-icon="mdi-email-sync-outline">
                Cancel Evoucher
              </v-btn>
            </v-sheet>  
          </div>
        </v-col>   
      </v-row>
    </v-container>

    <div>
        <Transition name="modal">
          <div v-if="showSendEmailDialog" class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-body">
                  <v-form >
                      <div class="d-flex d-flex-row pt-5 mb-5">
                        <h3 style="width:80%">Resend EVoucher Email</h3>
                        <v-btn icon="mdi-check-bold" type="submit" @click="resendEVoucherEmail" class="modal-save-button" size="x-small" variant="text">
                            <v-icon>mdi-check-bold</v-icon>
                            <v-tooltip
                              activator="parent"
                              location="top"
                            >Submit and Close</v-tooltip>
                          </v-btn>
                          <v-btn icon="mdi-close-thick" class="modal-cancel-button" @click="closeSendEmailDialog" size="x-small" variant="text">
                            <v-icon>mdi-close-thick</v-icon>
                            <v-tooltip
                              activator="parent"
                              location="top"
                            >Close</v-tooltip>
                          </v-btn>
                      </div>
                      
                      <v-text-field :rules="emailRules" label="Partner Email Address" type="email" v-model="newPartnerEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      <v-text-field :rules="emailRules" label="Distributor Email Address" type="email" v-model="newDistributorEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      <v-text-field label="My Email Address for Bcc" type="email" v-model="newUserEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                   
                  </v-form>                  
                </div>

                <div class="modal-footer">
                  <slot name="footer">
  
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>

      <div>
        <Transition name="modal">
          <div v-if="showCancelEVoucherDialog" class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-body">
                  <v-form >
                      <div class="d-flex d-flex-row pt-5 mb-5">
                        <h3 style="width:80%">Cancel EVoucher</h3>
                        <v-btn icon="mdi-check-bold" type="submit" @click="cancelEVoucher" class="modal-save-button" size="x-small" variant="text">
                            <v-icon>mdi-check-bold</v-icon>
                            <v-tooltip
                              activator="parent"
                              location="top"
                            >Submit and Close</v-tooltip>
                          </v-btn>
                          <v-btn icon="mdi-close-thick" class="modal-cancel-button" @click="closeCancelEVoucherDialog" size="x-small" variant="text">
                            <v-icon>mdi-close-thick</v-icon>
                            <v-tooltip
                              activator="parent"
                              location="top"
                            >Close</v-tooltip>
                          </v-btn>
                      </div>
                      
                      <v-text-field :rules="emailRules" label="Partner Email Address" type="email" v-model="newPartnerEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      <v-text-field :rules="emailRules" label="Distributor Email Address" type="email" v-model="newDistributorEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      <v-text-field label="My Email Address for Bcc" type="email" v-model="newUserEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                   
                  </v-form>                  
                </div>

                <div class="modal-footer">
                  <slot name="footer">
  
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>

      <div>
        <Transition name="modal">
          <div v-if="showExtendExpiryDateDialog" class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-body">
                  <v-form >
                      <div class="d-flex d-flex-row pt-5 mb-5">
                        <h3 style="width:80%">Extend Expiry Date</h3>
                        <v-btn icon="mdi-check-bold" type="submit" @click="extendExpiryDate" class="modal-save-button" size="x-small" variant="text">
                            <v-icon>mdi-check-bold</v-icon>
                            <v-tooltip
                              activator="parent"
                              location="top"
                            >Submit and Close</v-tooltip>
                          </v-btn>
                          <v-btn icon="mdi-close-thick" class="modal-cancel-button" @click="closeExtendExpiryDateDialog" size="x-small" variant="text">
                            <v-icon>mdi-close-thick</v-icon>
                            <v-tooltip
                              activator="parent"
                              location="top"
                            >Close</v-tooltip>
                          </v-btn>
                      </div>
                      
                      <v-sheet class="px-2 mx-2 mb-2">
                        <v-date-input
                          v-model="newEVoucherExpiryDate"
                          label="Expiry Date"
                          variant="underlined"
                          prepend-icon=""
                          persistent-placeholder
                          density="compact"
                          append-inner-icon="mdi-pencil"
                          :rules="expiryDateRules"      
                          readonly      
                        ></v-date-input> 
                      </v-sheet>

                      <v-text-field :rules="emailRules" label="Partner Email Address" type="email" v-model="newPartnerEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      <v-text-field :rules="emailRules" label="Distributor Email Address" type="email" v-model="newDistributorEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      <v-text-field label="My Email Address for Bcc" type="email" v-model="newUserEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
       

                  </v-form>                  
                </div>

                <div class="modal-footer">
                  <slot name="footer">
  
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>

      <div>
        <Transition name="modal">
          <div v-if="showReissueDialog" class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-body">
                  <v-form >
                      <div class="d-flex d-flex-row pt-5 mb-5">
                        <h3 style="width:80%">Re-issue EVoucher</h3><br/>
                        <v-btn icon="mdi-check-bold" type="submit" @click="reissueEVoucher" class="modal-save-button" size="x-small" variant="text">
                            <v-icon>mdi-check-bold</v-icon>
                            <v-tooltip
                              activator="parent"
                              location="top"
                            >Submit and Close</v-tooltip>
                          </v-btn>
                          <v-btn icon="mdi-close-thick" class="modal-cancel-button" @click="closeReissueDialog" size="x-small" variant="text">
                            <v-icon>mdi-close-thick</v-icon>
                            <v-tooltip
                              activator="parent"
                              location="top"
                            >Close</v-tooltip>
                          </v-btn>
                      </div>
                        
                      <v-sheet class="d-flex flex-row px-2 mx-2 mb-2">
                        <v-text-field
                          v-model="newQuarter"
                          label="Quarter"
                          variant="outlined"
                          readonly
                          density="compact"
                        ></v-text-field>
                      </v-sheet>

                      <v-sheet class="d-flex flex-row px-2 mx-2 mb-2">
                        <v-text-field
                          v-model="newDistributorAffinityId"
                          label="Distributor Affinity Id"
                          variant="underlined"
                          density="compact"
                          append-inner-icon="mdi-pencil"
                          :rules="distributorAffinityIdRules"
                        ></v-text-field>
                        <v-btn class="ml-2" @click="getDistributor" icon="mdi-magnify" size="small" variant="text">
                          <v-icon>mdi-find-replace</v-icon>
                          <v-tooltip
                            activator="parent"
                            location="top"
                          >Replace Distributor</v-tooltip>
                        </v-btn>
                      </v-sheet>

                      <v-sheet class="d-flex flex-row px-2 mx-2 mb-2">
                        <v-text-field
                          v-model="newDistributorName"
                          label="Distributor Name"
                          variant="outlined"
                          readonly
                          density="compact"
                          :rules="distributorNameRules"
                        ></v-text-field>
                      </v-sheet>

                      <v-sheet class="d-flex flex-row px-2 mx-2 mb-2">
                        <v-text-field
                          v-model="evoucher.availableAmount"
                          label="Available Amount (USD)"
                          variant="underlined"
                          readonly
                          density="compact"
                        ></v-text-field>
                      </v-sheet>

                      <v-sheet class="d-flex flex-row px-2 mx-2 mb-2">
                        <v-text-field
                          v-model="newUSDAmount"
                          label="EVoucher Value (USD)"
                          variant="underlined"
                          density="compact"
                          append-inner-icon="mdi-pencil"
                          :rules="amountRules"
                        ></v-text-field>
                        <v-btn class="ml-2" @click="recalculateLocalValue" icon="mdi-sigma" size="small" variant="text">
                          <v-icon>mdi-sigma</v-icon>
                          <v-tooltip
                            activator="parent"
                            location="top"
                          >Recalculate local value</v-tooltip>
                        </v-btn>
                      </v-sheet>

                      <v-sheet class="px-2 mx-2 mb-2">
                        <v-text-field
                          v-model="newLocalAmount"
                          :label="'Local Value (' + newLocalCurrency + ')'"
                          variant="outlined"
                          readonly
                          density="compact"
                          :rules="localAmountRules"
                        ></v-text-field>
                      </v-sheet>

                      <v-sheet class="px-2 mx-2 mb-2">
                        <v-date-input
                          v-model="newEVoucherExpiryDate"
                          label="Expiry Date"
                          variant="underlined"
                          prepend-icon=""
                          persistent-placeholder
                          density="compact"
                          append-inner-icon="mdi-pencil"
                          :rules="expiryDateRules"      
                          readonly      
                        ></v-date-input> 
                      </v-sheet>

                      <v-text-field :rules="emailRules" label="Partner Email Address" type="email" v-model="newPartnerEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      <v-text-field :rules="emailRules" label="Distributor Email Address" type="email" v-model="newDistributorEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      <v-text-field label="My Email Address for Bcc" type="email" v-model="newUserEmail" clearable density="comfortable" append-inner-icon="mdi-pencil"></v-text-field>
                      
                  </v-form>                  
                </div>

                <div class="modal-footer">
                  <slot name="footer">
  
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
  
      <v-dialog v-model="showHelp" width="950" scrollable>
      <v-card>
          <v-toolbar>
              <v-toolbar-title>EVoucher Action Guide</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">
              <v-list lines="five">
                <v-list-subheader>The are 4 actions available to you, <b>RE-SEND EMAIL</b>, <b>EXTEND EXPIRY DATE</b>, <b>RE-ISSUE EVOUCHER</b> and <b>CANCEL EVOUCHER</b></v-list-subheader>
                <v-list-item
                  v-for="item in guidelines"
                  :key="item.value"
                  :subtitle="item.subtitle"
                  :title="item.title"
                ></v-list-item>
              </v-list>
          </v-card-text>
          <v-card-actions class="border-t-thin">
              <v-btn @click="showHelp = false" width="100">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { useSystemStore } from '@/stores/system'
import { useDistributorStore } from '@/stores/distributor'

const distributorStore = useDistributorStore()
const systemStore = useSystemStore()

const headers = [
  { key: 'quarter', title: 'Quarter'},
  { key: 'eVoucherNumber', title: 'EVoucher'},
  { key: 'load', title: 'Load'}
]

const evouchers = ref([])
const showHelp = ref(false)


const guidelines = [
  { title: 'Re-send Email', subtitle: 'This option allows you to re-send the EVoucher notification email to the Partner and Distributor. Take note that the button is only available if the EVoucher Status is on Rewards Redeemed and the EVoucher has not expired.' },
  { title: 'Extend Expiry Date', subtitle: 'This option allows you to extend the Expiry Date of the EVoucher. Take note that the button is only available if the EVoucher Status is on Rewards Redeemed. You would use this option if NO details on the EVoucher needs to change. The existing EVoucher Number is retained. Notification emails will be sent to the Partner and Distributor. Optionally, if specified, you can Bcc the notifications to yourself.' },
  { title: 'Re-issue EVoucher', subtitle: 'This option allows you to re-issue an EVoucher into the current redemption period. Take note that the button is only available if the EVoucher Status is on Rewards Redeemed. You would use this option if details on the EVoucher needs to change. E.g. The Partner wishes to Utilise the EVoucher with a different Distributor. Cancellation notification emails as well as notification emails with the new EVoucher details will be sent to the Partner and Distributor. Optionally, if specified, you can Bcc the notifications to yourself.' },
  { title: 'Cancel EVoucher', subtitle: 'This option allows you to cancel an EVoucher. Take note that the button is only available if the EVoucher Status is on Rewards Redeemed. Cancellation notification emails will be sent to the Partner and Distributor. Optionally, if specified, you can Bcc the notifications to yourself.' }
]

const showSendEmailDialog = ref(false)
const showExtendExpiryDateDialog = ref(false)
const showReissueDialog = ref(false)
const showCancelEVoucherDialog = ref(false)

const eVoucherNumberSearch = ref('')
const evoucher = ref({})

const hasEVoucher = ref(false)
const noEVoucher = ref("") 

const quarters = ref([])

const newQuarter = ref('')
const newDistributorAffinityId = ref(0)
const newDistributorName = ref('')
const newDistributorCountry = ref('')
const newEVoucherExpiryDate = ref()
const newLocalAmount = ref(0)
const newLocalCurrency = ref('')
const newUSDAmount = ref(0)
const newDistributorEmail = ref('')
const newPartnerEmail = ref('')
const newUserEmail = ref('')

const distributorAffinityIdError = 'Enter a valid Distributor Affinity Id.'
const distributorNameError = 'Enter a valid Distributor Name.'
const amountError = 'Enter a valid EVoucher Value in USD.'
const amountError2 = 'Entered Value exceeds Available Amount.'
const localAmountError = 'Re-calculate a valid Local Value. Click the Σ button next to the EVoucher Value field.'
const expiryDateError = 'Enter a valid Expiry Date.'


const distributorAffinityIdRules = [
    value => (!!value && value > 0) || distributorAffinityIdError
]

const distributorNameRules = [
    value => (!!value && value != '') || distributorNameError
]

const amountRules = [
    value => (!!value && value > 0) || amountError,
    value => (value <= evoucher.value.availableAmount) || amountError2
]

const localAmountRules = [
    value => (!!value && value > 0) || localAmountError
]

const expiryDateRules = [
    value => !!value || expiryDateError,
    value => !isNaN(Date.parse(value)) || 'Invalid date format.',
    value => new Date(value) > new Date() || 'Date must be in the future.'
];

const emailRules = [ 
  value => (!!value && value != '') || 'You must enter an email address.',
 ]

const validateAgainstRules = (value, rules) => {
    for (const rule of rules) {
        const result = rule(value);
        if (result !== true) {
            return false;
        }
    }
    return true; 
};

const closeSendEmailDialog = () => {  
  showSendEmailDialog.value = false
}

const closeCancelEVoucherDialog = () => {  
  showCancelEVoucherDialog.value = false
}

const closeExtendExpiryDateDialog = () => {  
  showExtendExpiryDateDialog.value = false
}

const closeReissueDialog = () => {  
  showReissueDialog.value = false
}

const loadEVoucher = (eVoucherNumber) => {
  eVoucherNumberSearch.value = eVoucherNumber
  evoucherSearch()
}

const loadReissuedEVoucher = () => {
  eVoucherNumberSearch.value = evoucher.value.reissuedEVoucherNumber
  evoucherSearch()
}

const evoucherSearch = () => {
  if (eVoucherNumberSearch.value.trim().length === 0) {
    return
  }

  evoucher.value = {}
  hasEVoucher.value = false
  noEVoucher.value = ""

  systemStore.getEvoucher(eVoucherNumberSearch.value.trim()).then(result => {
    if (result.success) {
      hasEVoucher.value = true
      evoucher.value = result.eVoucherControlDTO
      newQuarter.value = quarters.value.find(q => q.currentRedemptionQuarter === true).quarter
      newDistributorAffinityId.value = evoucher.value.distributorAffinityId
      newDistributorName.value = evoucher.value.distributorName
      newDistributorCountry.value = evoucher.value.distributorCountry
      newLocalAmount.value = 0
      newLocalCurrency.value = evoucher.value.localCurrency
      newUSDAmount.value = evoucher.value.usdAmount
      newDistributorEmail.value = evoucher.value.distributorEmail
      newPartnerEmail.value = evoucher.value.partnerEmail
      newUserEmail.value = systemStore.userDetail.emailAddress

      getEvouchers()
    }
    else {
      noEVoucher.value = "No entries found."
    }
  }).catch(error => {
    console.log('getEvoucherForReissue', error)
  })
}

const recalculateLocalValue = () => {
  if (!validateAgainstRules(newUSDAmount.value, amountRules)) {
    return
  }

  systemStore.recalculateLocalValue(newUSDAmount.value
      , newLocalCurrency.value
      , evoucher.value.partnerCountry).then(result => {
    if (result.success) {
      newLocalAmount.value = parseFloat(result.localAmount).toFixed(2) 
      newLocalCurrency.value = result.localCurrency
    }
  }).catch(error => {
    console.log('recalculateLocalValue', error)
  })
}

const reissueEVoucher = () => {

  if (!validateAgainstRules(newDistributorAffinityId.value, distributorAffinityIdRules)) {
    return 
  }
  if (!validateAgainstRules(newDistributorName.value, distributorNameRules)) {
    return 
  }
  if (!validateAgainstRules(newUSDAmount.value, amountRules)) {
    return 
  }  
  if (!validateAgainstRules(newLocalAmount.value, localAmountRules)) {
    return 
  }
  if (!validateAgainstRules(newEVoucherExpiryDate.value, expiryDateRules)) {
    return 
  }
  if (!validateAgainstRules(newPartnerEmail.value, emailRules)) {
    return 
  }
  if (!validateAgainstRules(newDistributorEmail.value, emailRules)) {
    return 
  }

  evoucher.value.quarter = newQuarter.value
  evoucher.value.distributorAffinityId = newDistributorAffinityId.value
  evoucher.value.distributorName = newDistributorName.value
  evoucher.value.distributorCountry = newDistributorCountry.value
  evoucher.value.usdAmount = newUSDAmount.value
  evoucher.value.localAmount = newLocalAmount.value
  evoucher.value.localCurrency = newLocalCurrency.value
  evoucher.value.eVoucherExpiryDate = newEVoucherExpiryDate.value
  evoucher.value.partnerEmail = newPartnerEmail.value
  evoucher.value.distributorEmail = newDistributorEmail.value
  evoucher.value.userEmail = newUserEmail.value

  systemStore.reissueEVoucher(evoucher.value).then(result => {
    if (result.success) {
      evoucher.value = {}
      hasEVoucher.value = false
      noEVoucher.value = ""
      closeReissueDialog()
      evoucherSearch()
    }
  }).catch(error => {
    console.log('reissueEVoucher', error)
  })
}

const resendEVoucherEmail = () => {
  if (!validateAgainstRules(newPartnerEmail.value, emailRules)) {
    return 
  }
  if (!validateAgainstRules(newDistributorEmail.value, emailRules)) {
    return 
  }

  evoucher.value.partnerEmail = newPartnerEmail.value
  evoucher.value.distributorEmail = newDistributorEmail.value
  evoucher.value.userEmail = newUserEmail.value

  systemStore.resendEVoucherEmail(evoucher.value).then(result => {
    if (result.success) {
      closeSendEmailDialog()
    }
  }).catch(error => {
    console.log('resendEVoucherEmail', error)
  })
}

const cancelEVoucher = () => {
  if (!validateAgainstRules(newPartnerEmail.value, emailRules)) {
    return 
  }
  if (!validateAgainstRules(newDistributorEmail.value, emailRules)) {
    return 
  }

  evoucher.value.partnerEmail = newPartnerEmail.value
  evoucher.value.distributorEmail = newDistributorEmail.value
  evoucher.value.userEmail = newUserEmail.value

  systemStore.cancelEVoucher(evoucher.value).then(result => {
    if (result.success) {
      closeCancelEVoucherDialog()
    }
  }).catch(error => {
    console.log('cancelEVoucher', error)
  })
}

const extendExpiryDate = () => {
  if (!validateAgainstRules(newEVoucherExpiryDate.value, expiryDateRules)) {
    return 
  }
  if (!validateAgainstRules(newPartnerEmail.value, emailRules)) {
    return 
  }
  if (!validateAgainstRules(newDistributorEmail.value, emailRules)) {
    return 
  }

  evoucher.value.eVoucherExpiryDate = newEVoucherExpiryDate.value
  evoucher.value.partnerEmail = newPartnerEmail.value
  evoucher.value.distributorEmail = newDistributorEmail.value
  evoucher.value.userEmail = newUserEmail.value

  systemStore.extendExpiryDate(evoucher.value).then(result => {
    if (result.success) {
      closeExtendExpiryDateDialog()
    }
  }).catch(error => {
    console.log('extendExpiryDate', error)
  })
}

const getDistributor = () => {  
  if (newDistributorAffinityId.value > 0) {
      distributorStore.getDistributor(newDistributorAffinityId.value).then(result => {
      if (result.hasData) {
        newDistributorName.value = result.distributorCompany[0].companyName
        newDistributorEmail.value = result.distributorCompany[0].email
        newDistributorCountry.value = result.distributorCompany[0].country
      }
    })    
  }
} 

const getEvouchers = () => {  
  systemStore.getEvouchers(evoucher.value.partnerAffinityId).then(result => {
    if (result.success) {
      evouchers.value = result.eVouchers
    }
  }).catch(error => {
    console.log('getEvouchers', error)
  })
} 

const viewGuide = () => {
  showHelp.value = true
}

watch(
  newUSDAmount,
  () => {
    newLocalAmount.value = 0
  }
)

watch(
  newDistributorAffinityId,
  () => {
    newDistributorName.value = ''
  }
)

const canReissueEVoucher = computed(() => {
  return (evoucher.value.eVoucherStatusLink === 13 || evoucher.value.eVoucherStatusLink === 19)
})

const canResendEmail = computed(() => {
  let today = new Date()
  let expiryDate = new Date(evoucher.value.eVoucherExpiryDate)
  return (evoucher.value.eVoucherStatusLink === 13 || evoucher.value.eVoucherStatusLink === 19)
})

const canEntendExpiryDate = computed(() => {
  return (evoucher.value.eVoucherStatusLink === 13 || evoucher.value.eVoucherStatusLink === 19)
})

const canCancelEVoucher = computed(() => {
  return (evoucher.value.eVoucherStatusLink === 13 || evoucher.value.eVoucherStatusLink === 19)
})

onMounted(() => {
  systemStore.getQuarters().then(result => {
    if (result.success) {
      quarters.value = result.quarters
    }
  }).catch(error => {
    console.log('recalculateLocalValue', error)
  })
})

</script>

<style scoped>

.title {
  font-size: small;
}

.sub-title {
  font-size: smaller;
  font-weight: bold;
}

.modal-mask {
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 5px auto;
  padding: 5px 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-body {
  margin: 20px 0;
}

.modal-save-button {
  margin: 0px 10px;
}

.modal-cancel-button {
  margin: 0px 10px;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.evoucherList {
  position: absolute;
  right: 0;
}

</style>